import { render, staticRenderFns } from "./AveragePrice.vue?vue&type=template&id=7f7ea295&"
import script from "./AveragePrice.vue?vue&type=script&lang=js&"
export * from "./AveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports